<template>
  <div style="height: 100%" class="distribute">
    <DistributeFilters :loadNextPage="loadNextPage" />
    <v-progress-linear v-if="isLargeLoading" indeterminate></v-progress-linear>
    <v-container v-if="noRecordsFound" class="text-center py-10">
      No books found in stock.
    </v-container>
    <div class="books-listing-parent" ref="scrollable" v-bar>
      <div>
        <v-container
          :class="[isEmpty ? 'd-none' : '', !loadedAll ? 'pull-up-margin' : '']"
        >
          <v-row>
            <BookCard
              v-for="book in data"
              :key="book._id"
              :book="book"
              type="distribute"
              sm="6"
              xs="12"
              md="4"
              lg="4"
              cols="12"
            />
          </v-row>
        </v-container>
        <SkeltonLoader v-if="!loadedAll" />
      </div>
    </div>
  </div>
</template>

<script>
import { useDistribute } from "@/modules";
import BookCard from "@/components/BookCard";
import SkeltonLoader from "@/components/SkeltonLoader";
import DistributeFilters from "@/components/DistributeFilters";

export default {
  setup: useDistribute,
  components: {
    BookCard,
    SkeltonLoader,
    DistributeFilters
  }
};
</script>
